import { defineMessages } from 'react-intl';

export const servcoTemplateMessages = defineMessages({
	poweredByText: {
		id: 'TransparentTemplateV2.servco.poweredByText',
		defaultMessage: 'Powered by',
		description: 'Text indicating which Atlassian product powers the selected template',
	},
	legalNotice: {
		id: 'TransparentTemplateV2.servco.legalNotice',
		defaultMessage:
			"By continuing, you agree to the {customerAgreementLink} and {privacyPolicyLink}. You'll be provisioned to Service Collection and keep access to Jira on your site.",
		description:
			'Shown below the template cards when a Jira Service Management or Customer Service Management template is selected. Informs the user they accept the customer agreement and privacy policy, will be provisioned to Service Collection and keep access to Jira.',
	},
	customerAgreementLinkText: {
		id: 'TransparentTemplateV2.servco.customerAgreementLink',
		defaultMessage: 'Atlassian Customer Agreement',
		description: 'Link text for the Atlassian Customer Agreement legal document',
	},
	privacyPolicyLinkText: {
		id: 'TransparentTemplateV2.servco.privacyPolicyLink',
		defaultMessage: 'Privacy Policy',
		description: 'Link text for the Privacy Policy legal document',
	},
});
